import axios from 'axios';
import { ServerError, ServerValidationError } from '@/axios/exceptions';

/**
 * Response interceptors
 */
axios.interceptors.response.use(response => response, error => {
    if (error.response.status === 400) {
      return Promise.reject(new ServerValidationError(error.response));
    }
    return Promise.reject(new ServerError(error.response));
  },
);

export default axios;
